import { ChangeDetectionStrategy, Component, computed, input, signal, ViewEncapsulation } from '@angular/core';
import { Color, LegendPosition } from '@swimlane/ngx-charts';
import { CoreComponent } from 'lib/ui/core/core.component.js';
import { graphHelper } from '../graph.helper.js';
import { GraphLegendPosition, IMultiSeries } from '../graph.models.js';

@Component({
	selector: 'lib-line-chart',
	templateUrl: './line-chart.component.html',
	styleUrls: ['../graphs.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class LineChartComponent extends CoreComponent {
	public readonly legendPosition = input<GraphLegendPosition>();
	public readonly isDoughnut = input<boolean>(false);
	public readonly showLegend = input<boolean>(false);
	public readonly colorScheme = input<readonly string[]>();
	public readonly xAxisLabel = input<string>('');
	public readonly yAxisLabel = input<string>('');
	public readonly multiSeries = input.required<readonly IMultiSeries[]>();
	public readonly tooltipDisabled = graphHelper.isTooltipDisabled;

	public readonly showAxisLabels = computed<boolean>(() => {
		if (this.isMobileView()) {
			return false;
		}
		return true;
	});

	public readonly colorsDomain = signal<Color>(graphHelper.getDefaultColorScheme());
	public readonly legendPositionCalculated = computed<LegendPosition>(() => {
		return this.legendPosition() === 'right' ? LegendPosition.Right : LegendPosition.Below;
	});

	public readonly showGraph = computed<boolean>(() => {
		const multiSeries = this.multiSeries();

		for (const multiSerie of multiSeries) {
			if (multiSerie.series.length) {
				return true;
			}
		}
		return false;
	});

	constructor() {
		super();
	}
}
